import AssertionError from 'shared/errors/AssertionError'

// eslint-disable-next-line max-params
const assert = (condition, message, ...codes) => {
  if (!condition) {
    throw new AssertionError(message || 'Assertion failed', ...codes)
  }
}

export default assert
